import { useQuery } from "react-query";
import { fetchPandaDocSessionForDocument } from "api/document";

const useGetPandaDocSessionForDocument = (documentId: string, enabled = true) => {
  const { data, isLoading, error, refetch } = useQuery(
    ["pandaDocSessionForDocument", documentId],
    async () => {
      const response = await fetchPandaDocSessionForDocument(documentId);
      return response?.data ?? response;
    },
    {
      enabled: enabled && !!documentId,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      onError: (err) => {
        console.error(
          "Error fetching PandaDoc session for document:",
          err?.response?.status ? `HTTP ${err.response.status}` : err?.message
        );
      },
    }
  );

  return {
    pandaDocSession: data,
    isLoading,
    error,
    refetch,
  };
};

export default useGetPandaDocSessionForDocument;
